import apiClient from './api.service';

const WithdrawalService = {
  // Get all withdrawals
  getAllWithdrawals() {
    return apiClient.get('/withdrawl');
  },

  // Get withdrawal by ID
  getWithdrawalById(id) {
    return apiClient.get(`/withdrawl/${id}`);
  },

  // Get withdrawals by user (teacher)
  getWithdrawalsByUser(userId) {
    return apiClient.get(`/withdrawl/byUser/${userId}`);
  },

  // Get pending withdrawals
  getPendingWithdrawals() {
    return apiClient.get('/withdrawl/admin/pending');
  },

  // Approve withdrawal
  approveWithdrawal(withdrawalId, data) {
    return apiClient.post(`/withdrawl/admin/approve/${withdrawalId}`, data);
  },

  // Reject withdrawal
  rejectWithdrawal(withdrawalId, reason) {
    return apiClient.post(`/withdrawl/admin/reject/${withdrawalId}`, { reason });
  },

  // Get withdrawal statistics
  getWithdrawalStats() {
    return apiClient.get('/withdrawl/admin/stats');
  }
};

export default WithdrawalService;
